// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* src/components/Main.css */

body, html {
    margin: auto;
    padding: 0.2rem;
    overflow-x: hidden;
    background-color: #364c63;
  }
  
  
  #root { 
    overflow-x: hidden;
  }
  
  .element-style{
    overflow-x: hidden;
  }
    
  .column{
    overflow-x: hidden;
  }
  

  
  `, "",{"version":3,"sources":["webpack://./src/components/Main/Main.css"],"names":[],"mappings":"AAAA,4BAA4B;;AAE5B;IACI,YAAY;IACZ,eAAe;IACf,kBAAkB;IAClB,yBAAyB;EAC3B;;;EAGA;IACE,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;EACpB","sourcesContent":["/* src/components/Main.css */\n\nbody, html {\n    margin: auto;\n    padding: 0.2rem;\n    overflow-x: hidden;\n    background-color: #364c63;\n  }\n  \n  \n  #root { \n    overflow-x: hidden;\n  }\n  \n  .element-style{\n    overflow-x: hidden;\n  }\n    \n  .column{\n    overflow-x: hidden;\n  }\n  \n\n  \n  "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
